import "./Terms.scss";

import React from "react";

export default () => (
  <div className="TermsContainer">
    <title>
      Quantum Country User Agreement and Privacy Policy | Quantum Country
    </title>
    <h2>Quantum Country User Agreement and Privacy Policy</h2>
    <p>
      This is an experimental medium, and if you create an account we will track
      your responses to questions and send you notifications. Note that the data
      is shared with <a href="https://www.google.com">Google LLC</a> (for
      storage and analytics); Functional Software, Inc. (via their error
      monitoring service <a href="https://sentry.io">Sentry</a>),{" "}
      <a href="https://www.mailjet.com">Mailjet, Inc.</a> (for email
      notifications); and <a href="https://www.mailjet.com">Twilio, Inc.</a>{" "}
      (for SMS notifications). We'll use the data for research purposes, and may
      sometimes publish that research, with users anonymized.
    </p>

    <p>
      If you'd like to withdraw consent for our use of your data, would like
      your data forgotten, would like access to your data, or would like to stop
      receiving notifications, please{" "}
      <a href="mailto:mn@michaelnielsen.org;andy@andymatuschak.org">email us</a>
      .
    </p>
  </div>
);
